export function LogMessage(msg, force = false) {
    const inDev = !PROD_BUILD;
    if (inDev || force) {
        console.log(msg);
    }
}
export function getTimestamp() {
    return Math.floor(new Date().getTime() / 1000);
}
export function Sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function IsPaidCycleValid(cycleEndTime) {
    const endDate = new Date(cycleEndTime);
    const currentDate = new Date();
    endDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    return currentDate <= endDate;
}
